module.exports = __webpack_public_path__ + "img/cryptexA.eba9ba46.png";